<template>
  <div class="purchase-order-actions">
    <div class="search">
      <tol-type-ahead
        :display-value="purchaseOrderSearchParam"
        :search-params="{
          url: '/purchase-orders/list',
          searchKeys: ['searchParam'],
          urlParams: {
            recordsPerPage: purchaseOrdersRecordsPerpage,
            offset: purchaseOrdersRecordsOffset,
            sortBy: purchaseOrdersSortField,
            sortDirection: purchaseOrdersSortDirection
          }
        }"
        :results-in-dropdown="false"
        @filtered="onFiltered($event)"
        @search-in-progress="onSearchInProgress($event)"
      >
      </tol-type-ahead>
    </div>
    <div class="actions">
      <router-link to="/purchase-orders/create">
        <TolAltButton icon-name="plus" label="New Purchase Order" />
      </router-link>
    </div>
  </div>
</template>
<script>
import TolAltButton from '@/app/components/TolAltButton';
import TolTypeAhead from '@/app/components/TolTypeAhead';
import {
  PurchaseOrdersListingGetters,
  PurchaseOrdersListingActions
} from '../purchase-orders-listing.keys';
export default {
  name: 'PurchaseOrderActions',
  components: {
    TolAltButton,
    TolTypeAhead
  },
  computed: {
    purchaseOrdersRecordsPerpage() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersPerPage];
    },
    purchaseOrdersRecordsOffset() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersListingOffset];
    },
    purchaseOrdersSortField() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersSortBy];
    },
    purchaseOrdersSortDirection() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersSortDirection];
    },
    purchaseOrderSearchParam() {
      return this.$store.getters[PurchaseOrdersListingGetters.PurchaseOrdersSearchParam];
    }
  },
  methods: {
    onSearchInProgress(searchFlag) {
      this.$emit('load-spinner', searchFlag);
    },
    onFiltered(results) {
      this.$emit('load-spinner', false);
      this.$store.dispatch(PurchaseOrdersListingActions.UpdatePurchaseOrdersList, results);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.purchase-order-actions {
  display: flex;
  background-color: $background-level-2;
  padding: 60px;
  align-items: center;

  .search {
    display: flex;
    flex-basis: 50%;
    .search-container {
      flex: 1;
    }
  }

  .actions {
    display: flex;
    flex-basis: 25%;
    margin-left: auto;
    justify-content: flex-end;
    a {
      text-decoration: none;
      color: inherit;
    }
  }
}
</style>
